var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgstatus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 74,
    viewBox: "0 0 145 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0355 29.2183C44.0388 39.711 56.5852 46.0668 70.3632 47.1142C84.1411 48.1615 97.5026 43.7751 107.986 34.7637C118.469 25.7522 124.819 13.1944 125.865 -0.596093C126.912 -14.3865 122.529 -27.7602 113.526 -38.2529C104.523 -48.7457 91.9764 -55.1015 78.1985 -56.1488C64.4206 -57.1961 51.0591 -52.8097 40.5759 -43.7983C30.0927 -34.7868 23.7426 -22.229 22.6963 -8.43855C21.6499 5.35189 26.0323 18.7256 35.0355 29.2183ZM34.7815 29.4366C16.0464 7.60202 18.5429 -25.3003 40.3577 -44.0525C62.1725 -62.8047 95.045 -60.3059 113.78 -38.4713C132.515 -16.6367 130.019 16.2657 108.204 35.0179C86.3892 53.7701 53.5167 51.2713 34.7815 29.4366Z",
    fill: "url(#paint0_linear_1309_125149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5188 26.7353C55.5512 36.0966 66.7442 41.7649 79.0348 42.6991C91.3253 43.6334 103.248 39.7199 112.598 31.6823C121.948 23.6447 127.614 12.4394 128.547 0.137665C129.481 -12.1641 125.571 -24.0973 117.541 -33.4561C109.51 -42.8149 98.3151 -48.4857 86.0245 -49.4199C73.7339 -50.3542 61.8116 -46.4407 52.4613 -38.4031C43.111 -30.3655 37.4454 -19.1602 36.5119 -6.85846C35.5785 5.4433 39.4863 17.3739 47.5188 26.7353ZM47.2648 26.9536C30.5366 7.45806 32.7678 -21.9162 52.2432 -38.6573C71.7185 -55.3985 101.069 -53.1674 117.795 -33.6744C134.52 -14.1814 132.294 15.1932 112.816 31.9365C93.3383 48.6799 63.9907 46.4466 47.2648 26.9536Z",
    fill: "url(#paint1_linear_1309_125149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0002 24.2498C67.0597 32.4772 76.8987 37.4627 87.7067 38.2843C98.5147 39.1058 108.991 35.667 117.213 28.5989C125.435 21.5308 130.414 11.685 131.235 0.867196C132.056 -9.9506 128.62 -20.436 121.558 -28.666C114.496 -36.8959 104.66 -41.8788 93.8516 -42.7004C83.0436 -43.5219 72.5677 -40.0831 64.3453 -33.015C56.1228 -25.9469 51.1444 -16.1011 50.3236 -5.28331C49.5028 5.53449 52.9407 16.0224 60.0002 24.2498ZM59.7461 24.4682C45.0272 7.31423 46.9887 -18.537 64.1271 -33.2693C81.2655 -48.0016 107.093 -46.0383 121.812 -28.8843C136.531 -11.7303 134.57 14.1208 117.431 28.8532C100.293 43.5855 74.4651 41.6222 59.7461 24.4682Z",
    fill: "url(#paint2_linear_1309_125149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4835 21.7669C85.0536 36.4165 107.189 38.0992 121.825 25.5176C136.462 12.9361 138.143 -9.21936 125.573 -23.869C113.003 -38.5187 90.8672 -40.2013 76.2308 -27.6198C61.5945 -15.0382 59.9134 7.11723 72.4835 21.7669ZM72.2295 21.9852C59.5176 7.17032 61.2112 -15.1505 76.0127 -27.874C90.8141 -40.5975 113.115 -38.9023 125.827 -24.0874C138.539 -9.27245 136.845 13.0484 122.043 25.7719C107.242 38.4953 84.9414 36.8001 72.2295 21.9852Z",
    fill: "url(#paint3_linear_1309_125149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9668 19.284C95.5321 31.5971 114.136 33.0112 126.438 22.4364C138.739 11.8615 140.152 -6.75889 129.587 -19.072C119.022 -31.3851 100.418 -32.7993 88.1164 -22.2244C75.8145 -11.6496 74.4016 6.97084 84.9668 19.284ZM84.7128 19.5023C74.0101 7.02902 75.4363 -11.7663 87.8982 -22.4787C100.36 -33.1911 119.138 -31.7637 129.841 -19.2904C140.544 -6.81707 139.12 11.976 126.658 22.6884C114.196 33.4009 95.4155 31.9756 84.7128 19.5023Z",
    fill: "url(#paint4_linear_1309_125149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4505 16.7964C106.011 26.773 121.087 27.919 131.055 19.3509C141.022 10.7827 142.167 -4.30743 133.607 -14.284C125.047 -24.2606 109.97 -25.4067 100.003 -16.8385C90.0351 -8.2703 88.8901 6.81979 97.4505 16.7964ZM97.1965 17.0148C88.5009 6.88051 89.6595 -8.38917 99.7845 -17.0927C109.91 -25.7963 125.165 -24.6366 133.861 -14.5024C142.557 -4.36816 141.396 10.9037 131.271 19.6073C121.145 28.3109 105.892 27.149 97.1965 17.0148Z",
    fill: "url(#paint5_linear_1309_125149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.934 14.3134C116.49 21.9535 128.034 22.8311 135.667 16.2696C143.301 9.70803 144.177 -1.84702 137.622 -9.48711C131.066 -17.1272 119.522 -18.0048 111.888 -11.4432C104.255 -4.88171 103.379 6.67335 109.934 14.3134ZM109.68 14.5318C102.994 6.73915 103.885 -5.00494 111.67 -11.6975C119.456 -18.39 131.189 -17.4981 137.876 -9.70546C144.562 -1.91283 143.671 9.83127 135.886 16.5238C128.1 23.2163 116.367 22.3244 109.68 14.5318Z",
    fill: "url(#paint6_linear_1309_125149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.417 11.8306C126.968 17.1342 134.981 17.7432 140.28 13.1884C145.578 8.63354 146.187 0.613528 141.636 -4.69004C137.086 -9.99361 129.073 -10.6027 123.774 -6.04784C118.475 -1.49299 117.867 6.52702 122.417 11.8306ZM122.163 12.0489C117.484 6.59537 118.11 -1.62059 123.556 -6.30209C129.002 -10.9836 137.213 -10.3594 141.89 -4.90839C146.57 0.54518 145.944 8.76114 140.498 13.4426C135.052 18.1241 126.841 17.5 122.163 12.0489Z",
    fill: "url(#paint7_linear_1309_125149)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.898 9.34515C137.444 12.3122 141.93 12.6532 144.894 10.105C147.859 7.55681 148.199 3.06711 145.653 0.100064C143.108 -2.86698 138.622 -3.20795 135.658 -0.659768C132.693 1.89314 132.353 6.3781 134.898 9.34515ZM134.644 9.56351C131.974 6.45154 132.328 1.76082 135.439 -0.914014C138.549 -3.58666 143.235 -3.2328 145.907 -0.118289C148.58 2.99622 148.222 7.6866 145.112 10.3592C142.001 13.0341 137.317 12.678 134.644 9.56351Z",
    fill: "url(#paint8_linear_1309_125149)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1309_125149",
    x1: 44.5928,
    y1: 27.9794,
    x2: 85.1567,
    y2: 61.0584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1309_125149",
    x1: 56.0243,
    y1: 25.6526,
    x2: 92.2395,
    y2: 55.1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1309_125149",
    x1: 67.4545,
    y1: 23.3233,
    x2: 99.3238,
    y2: 49.3121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1309_125149",
    x1: 78.886,
    y1: 20.9965,
    x2: 106.407,
    y2: 43.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1309_125149",
    x1: 90.3176,
    y1: 18.6699,
    x2: 113.49,
    y2: 37.5664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1309_125149",
    x1: 101.75,
    y1: 16.3384,
    x2: 120.576,
    y2: 31.6909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1309_125149",
    x1: 113.182,
    y1: 14.0117,
    x2: 127.66,
    y2: 25.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1309_125149",
    x1: 124.613,
    y1: 11.685,
    x2: 134.743,
    y2: 19.9452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1309_125149",
    x1: 136.043,
    y1: 9.35574,
    x2: 141.827,
    y2: 14.0719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3C7EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448899,
    stopColor: "#00bcd4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30B1E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgstatus4);
export default __webpack_public_path__ + "static/media/imgstatus4.ee5c6778e11bb08c661302acd5f4d9ec.svg";
export { ForwardRef as ReactComponent };